// assets/js/video-modal.js
// Gestion d'une modale vidéo déclenchée par .js-video-trigger
// Supporte data-type="iframe"|"video", data-src, data-poster, data-title, data-description

let modalRoot = null;
let currentMediaEl = null;

function buildModal() {
  if (modalRoot) return modalRoot;

  modalRoot = document.createElement('div');
  modalRoot.className = 'hitech-video-modal fixed inset-0 z-[9999] hidden';
  modalRoot.innerHTML = `
    <div class="hv-backdrop absolute inset-0 bg-black/70"></div>
    <div class="hv-dialog absolute inset-0 grid place-items-center p-4">
      <div class="hv-panel relative w-full max-w-5xl bg-black rounded-xl overflow-hidden">
        <button type="button" class="hv-close absolute right-3 top-3 z-10
                h-10 w-10 grid place-items-center rounded-full bg-black/60 text-white"
                aria-label="Fermer la vidéo">✕</button>
        <div class="hv-media-wrapper relative w-full">
          <!-- media injecté ici -->
        </div>
        <div class="hv-caption p-4 text-white hidden">
          <h3 class="hv-title text-lg font-medium mb-2"></h3>
          <div class="hv-desc opacity-80 text-sm"></div>
        </div>
      </div>
    </div>
  `;
  document.body.appendChild(modalRoot);

  // Fermetures
  modalRoot.querySelector('.hv-backdrop').addEventListener('click', closeModal);
  modalRoot.querySelector('.hv-close').addEventListener('click', closeModal);
  document.addEventListener('keydown', (e) => {
    if (!modalRoot.classList.contains('hidden') && e.key === 'Escape') closeModal();
  });

  return modalRoot;
}

function stopAndCleanup() {
  if (!currentMediaEl) return;
  try {
    if (currentMediaEl.tagName === 'VIDEO') currentMediaEl.pause();
    // iframes : on retire carrément l'iframe pour stopper le player
  } catch (_) {}
  const wrap = modalRoot.querySelector('.hv-media-wrapper');
  wrap.innerHTML = '';
  currentMediaEl = null;
}

function openModal({ type, src, poster, title, description }) {
  const root = buildModal();
  stopAndCleanup();

  const wrap = root.querySelector('.hv-media-wrapper');

  if (type === 'iframe') {
    const iframe = document.createElement('iframe');
    iframe.className = 'w-full aspect-video';
    iframe.setAttribute('allowfullscreen', '');
    iframe.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture');
    iframe.setAttribute('referrerpolicy', 'no-referrer-when-downgrade');
    iframe.src = src; // src déjà avec autoplay=1 dans ton Twig
    iframe.setAttribute('data-modal-video', '');
    currentMediaEl = iframe;
    wrap.appendChild(iframe);
  } else {
    const video = document.createElement('video');
    video.className = 'w-full h-auto block';
    video.setAttribute('playsinline', '');
    video.setAttribute('controls', '');
    video.setAttribute('autoplay', '');
    // par défaut, pour l'autoplay fiable :
    video.muted = true;
    if (poster) video.setAttribute('poster', poster);
    const source = document.createElement('source');
    source.src = src;
    video.appendChild(source);
    video.setAttribute('data-modal-video', '');
    currentMediaEl = video;
    wrap.appendChild(video);
    // tente play()
    video.play().catch(() => {});
  }

  // Légendes
  const cap = root.querySelector('.hv-caption');
  const tEl = root.querySelector('.hv-title');
  const dEl = root.querySelector('.hv-desc');
  if (title || description) {
    cap.classList.remove('hidden');
    tEl.textContent = title || '';
    dEl.innerHTML = description || '';
  } else {
    cap.classList.add('hidden');
    tEl.textContent = '';
    dEl.innerHTML = '';
  }

  // Affiche
  root.classList.remove('hidden');
  document.documentElement.classList.add('hv-no-scroll');
  document.dispatchEvent(new CustomEvent('hitech:modal-open', { detail: { type: 'video' } }));
}

function closeModal() {
  if (!modalRoot || modalRoot.classList.contains('hidden')) return;
  stopAndCleanup();
  modalRoot.classList.add('hidden');
  document.documentElement.classList.remove('hv-no-scroll');
  document.dispatchEvent(new CustomEvent('hitech:modal-close', { detail: { type: 'video' } }));
}

function onTriggerClick(e) {
  const btn = e.currentTarget;
  const type = btn.getAttribute('data-type') || 'video'; // 'iframe' | 'video'
  const src  = btn.getAttribute('data-src')  || '';
  if (!src) return;
  openModal({
    type,
    src,
    poster: btn.getAttribute('data-poster') || '',
    title: btn.getAttribute('data-title') || '',
    description: btn.getAttribute('data-description') || ''
  });
}

function bindTriggers(scope = document) {
  scope.querySelectorAll('.js-video-trigger').forEach((btn) => {
    if (!btn.__hvBound) {
      btn.addEventListener('click', onTriggerClick);
      btn.__hvBound = true;
    }
  });
}

/** Init public */
export function initHiTechVideoModal() {
  buildModal();
  bindTriggers();

  // (Option) si du contenu est injecté dynamiquement :
  const mo = new MutationObserver((muts) => {
    muts.forEach((m) => {
      m.addedNodes.forEach((n) => {
        if (n.nodeType === 1) bindTriggers(n);
      });
    });
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
}
